export const CalendarIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentIcon = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="40" height="40" rx="20" fill="#F2F5F9" />
    <path
      d="M21.6668 12.3912V15.8333C21.6668 16.3 21.6668 16.5334 21.7577 16.7117C21.8376 16.8685 21.965 16.9959 22.1218 17.0758C22.3001 17.1667 22.5335 17.1667 23.0002 17.1667H26.4423M26.6668 18.8235V24.8333C26.6668 26.2335 26.6668 26.9335 26.3943 27.4683C26.1547 27.9387 25.7722 28.3212 25.3018 28.5609C24.767 28.8333 24.067 28.8333 22.6668 28.8333H17.3335C15.9334 28.8333 15.2333 28.8333 14.6985 28.5609C14.2281 28.3212 13.8457 27.9387 13.606 27.4683C13.3335 26.9335 13.3335 26.2335 13.3335 24.8333V16.1667C13.3335 14.7665 13.3335 14.0665 13.606 13.5317C13.8457 13.0613 14.2281 12.6788 14.6985 12.4392C15.2333 12.1667 15.9334 12.1667 17.3335 12.1667H20.01C20.6215 12.1667 20.9272 12.1667 21.2149 12.2357C21.47 12.297 21.7139 12.398 21.9375 12.5351C22.1898 12.6897 22.406 12.9059 22.8384 13.3382L25.4953 15.9951C25.9276 16.4275 26.1438 16.6437 26.2984 16.896C26.4355 17.1196 26.5365 17.3635 26.5978 17.6186C26.6668 17.9063 26.6668 18.212 26.6668 18.8235Z"
      stroke="#677389"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
